import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';

import toastReducer from './toastSlice';

export const store = configureStore({
  reducer: {
    toast: toastReducer,
  },
  middleware: [thunk],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
